import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "@services/axiosConfig";
  
const shipDetails = createAsyncThunk("owner/shipDetails", async () => {
    const { data } = await instance.get(
      `admin/getShipdetails`
    );
        return data;
  });
  
  export { shipDetails };
